import {
	Button,
	Flex,
	FormControl,
	FormLabel,
	Grid,
	GridItem,
	Heading,
	Image,
	Input,
	InputGroup,
	InputLeftElement,
	Select,
	Text,
	Textarea,
	useDisclosure,
	useToast,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useRef, useState } from "react";
import CustomSpinner from "../Spinner/CustomSpinner";

const SubmitPropertyForm1 = (props) => {
	const {
		register,
		errors,
		uploadedImages,
		setUploadedImages,
		fileError,
		setFileError,
	} = props;
	const toast = useToast();
	const token = sessionStorage.getItem("token");
	const [selectedFile, setSelectedFile] = useState();
	const inputRef = useRef(null);
	const { isOpen, onOpen, onClose } = useDisclosure();
	const allowedFileTypes = [
		"image/jpg",
		"image/gif",
		"image/png",
		"image/jpeg",
	];

	const handleChangeFile = async (e) => {
		if (e.target.files[0]) {
			console.log("File type is: ", e.target.files[0].type.split("/")[1]);
			console.log("File uploaded is: ", e.target.files);
			let isAllIncluded = true;
			Array.from(e.target.files).forEach((element) => {
				if (!allowedFileTypes.includes(element.type)) {
					isAllIncluded = false;
				}
			});
			if (isAllIncluded) {
				setSelectedFile(e.target.files);
				setFileError();
			} else {
				setFileError("Only images are allowed");
			}
		}
	};

	const handleUploadFile = async (e) => {
		if (!fileError) {
			if (selectedFile) {
				onOpen();
				const formData = new FormData();
				Array.from(selectedFile).forEach((element) => {
					formData.append("files", element);
				});
				await axios
					.post(
						"https://asset-tokenization-liart.vercel.app/s3/upload",
						formData,
						{
							headers: {
								Authorization: `Bearer ${token}`,
							},
						}
					)
					.then((response) => {
						console.log(
							"Response from getting picture upload data: ",
							response
						);
						setSelectedFile();
						inputRef.current.value = null;
						setFileError();
						setUploadedImages([...uploadedImages, ...response.data]);
						onClose();
					})
					.catch((error) => {
						console.log("Error from getting picture upload data: ", error);
						toast({
							title: "Error occured",
							description: error?.response?.data?.message,
							status: "error",
							duration: 4000,
							isClosable: true,
							position: "bottom-left",
						});
						setFileError("Error in file");
						onClose();
					});
			} else {
				setFileError("Select a file to upload");
			}
		}
	};

	return (
		<>
			<Heading w="100%" textAlign={"center"} fontWeight="normal" mb="2%">
				Property Detail
			</Heading>
			<Grid templateColumns={"repeat(2, 1fr)"} gap={5}>
				<GridItem colSpan={{ base: 2, lg: 1 }}>
					<FormControl>
						<FormLabel htmlFor="first-name" fontWeight={"normal"}>
							Property Name
						</FormLabel>
						<Input
							// id="first-name"
							placeholder="Property Name"
							{...register("propertyName", {
								required: "Property name is required",
							})}
						/>
						{errors.propertyName && (
							<Text color="red">{errors.propertyName.message}</Text>
						)}
					</FormControl>
				</GridItem>

				<GridItem colSpan={{ base: 2, lg: 1 }}>
					<FormControl>
						<FormLabel htmlFor="last-name" fontWeight={"normal"}>
							Ticker Symbol
						</FormLabel>
						<Input
							// id="last-name"
							placeholder="Ticker Symbol"
							{...register("tickerSymbol", {
								required: "Ticker Symbol is required",
							})}
						/>
						{errors.tickerSymbol && (
							<Text color="red">{errors.tickerSymbol.message}</Text>
						)}
					</FormControl>
				</GridItem>
			</Grid>

			<FormControl mt="2%">
				<FormLabel htmlFor="email" fontWeight={"normal"}>
					Address
				</FormLabel>
				<Input
					// id="email"
					placeholder="Address"
					{...register("propertyAddress", {
						required: "Property address is required",
					})}
				/>
				{errors.propertyAddress && (
					<Text color="red">{errors.propertyAddress.message}</Text>
				)}
				{/* <FormHelperText>We&apos;ll never share your email.</FormHelperText> */}
			</FormControl>

			<FormControl>
				<FormLabel fontWeight={"normal"} mt="2%">
					Map Location
				</FormLabel>
				<Input
					pr="4.5rem"
					placeholder="Map Location"
					{...register("mapLocation", {
						required: "Map Location is required",
						pattern: {
							value: /https?:\/\/(www\.)?google\.com\/maps\/place\/(.+)\/@[-?\d\.]+,[-?\d\.]+,?([\d]+)z?/,
							message: "This link doesn't match google maps link"
						}
					})}
				/>
				{errors.mapLocation && (
					<Text color="red">{errors.mapLocation.message}</Text>
				)}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Property Description</FormLabel>
				<Textarea
					{...register("propertyDescription", {
						required: "Property Description is required",
					})}
					placeholder="Enter the description of property"
				/>
				{errors.propertyDescription && (
					<Text color="red">{errors.propertyDescription.message}</Text>
				)}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Brochure</FormLabel>
				<Input
					placeholder="Property Brochure"
					{...register("propertyBrochure", {
						pattern: {
							value: /https:\/\/www\.[^\s]+/,
							message: "Please provide a valid link"
						}
					})}
				/>
				{errors.propertyBrochure && (
					<Text color="red">{errors.propertyBrochure.message}</Text>
				)}
			</FormControl>

			<Grid mt="2%" templateColumns={"repeat(2, 1fr)"} gap={5}>
				<GridItem colSpan={{ base: 2, lg: 1 }}>
					<FormControl>
						<FormLabel>Property Type</FormLabel>
						<Select
							placeholder="Select Property Type"
							{...register("propertyType", {
								required: "Property Type is required",
							})}
						>
							<option value="Apartments">Apartments</option>
							<option value="Office">Office</option>
							<option value="Retail">Retail</option>
							<option value="Hospitality">Hospitality</option>
							<option value="Industrial">Industrial</option>
							<option value="MixedUse">Mixed Use</option>
							<option value="Condominium">Condominium</option>
						</Select>
						{errors.propertyType && (
							<Text color="red">{errors.propertyType.message}</Text>
						)}
					</FormControl>
				</GridItem>

				<GridItem colSpan={{ base: 2, lg: 1 }}>
					<FormControl>
						<FormLabel>Property Class</FormLabel>
						<Select
							placeholder="Select Property Type"
							{...register("propertyClass", {
								required: "Property Class is required",
							})}
						>
							<option value="A">A</option>
							<option value="B">B</option>
							<option value="C">C</option>
							<option value="Mixed">Mixed</option>
						</Select>
						{errors.propertyClass && (
							<Text color="red">{errors.propertyClass.message}</Text>
						)}
					</FormControl>
				</GridItem>
			</Grid>

			<Grid mt="2%" templateColumns={"repeat(2, 1fr)"} gap={5}>
				<GridItem colSpan={{ base: 2, lg: 1 }}>
					<FormControl>
						<FormLabel>Status</FormLabel>
						<Select
							placeholder="Select Property Status"
							{...register("propertyStatus", {
								required: "Property Status is required",
							})}
						>
							<option value="coming soon">Coming Soon</option>
							<option value="express interest">Express Interest</option>
							<option value="live sale">Live Sale</option>
							<option value="coming">Closing</option>
							<option value="closed">Closed</option>
						</Select>
						{errors.propertyStatus && (
							<Text color="red">{errors.propertyStatus.message}</Text>
						)}
					</FormControl>
				</GridItem>

				<GridItem colSpan={{ base: 2, lg: 1 }}>
					<FormControl>
						<FormLabel>Property Risk Level</FormLabel>
						<Select
							placeholder="Select Property Risk Level"
							{...register("propertyRiskLevel", {
								required: "Property Risk Level is required",
							})}
						>
							<option value="Low">Low</option>
							<option value="Medium">Medium</option>
							<option value="High">High</option>
						</Select>
						{errors.propertyRiskLevel && (
							<Text color="red">{errors.propertyRiskLevel.message}</Text>
						)}
					</FormControl>
				</GridItem>
			</Grid>

			<FormControl mt="2%">
				<FormLabel>Creator Email</FormLabel>
				<Input
					type="email"
					w="full"
					rounded="md"
					placeholder="Email"
					{...register("creatorEmail", {
						required: "Creator Email is required",
					})}
				/>
				{errors.creatorEmail && (
					<Text color="red">{errors.creatorEmail.message}</Text>
				)}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Minimum Investment</FormLabel>
				<InputGroup>
					<InputLeftElement pointerEvents="none" children="$" />
					<Input
						w="full"
						rounded="md"
						type="number"
						placeholder="Minimum Investment"
						{...register("minimumInvestment", {
							required: "Minimum Investment is required",
							min: {
								value: 1,
								message: "Minimum Investment required is $1",
							},
						})}
					/>
				</InputGroup>
				{errors.minimumInvestment && (
					<Text color="red">{errors.minimumInvestment.message}</Text>
				)}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Total Shares</FormLabel>
				<Input
					w="full"
					rounded="md"
					type="number"
					placeholder="Total Shares"
					{...register("totalShares", {
						required: "Total Shares is required",
					})}
				/>
				{errors.totalShares && (
					<Text color="red">{errors.totalShares.message}</Text>
				)}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Images</FormLabel>
				<Grid templateColumns={"repeat(2, 1fr)"} gap={5}>
					<GridItem colSpan={{ base: 2, lg: 1 }}>
						<Input
							type="file"
							border="none"
							borderRadius="0px"
							padding="0px"
							multiple
							onChange={handleChangeFile}
							ref={inputRef}
							accept={allowedFileTypes.join(",")}
						/>
						{fileError && <Text color="red">{fileError}</Text>}
					</GridItem>
					<GridItem
						colSpan={{ base: 2, lg: 1 }}
						display={"flex"}
						justifyContent={{ base: "flex-start", lg: "flex-end" }}
					>
						<Button
							onClick={handleUploadFile}
							bgColor="#002B5B"
							color="white"
							_hover={{
								bgColor: "#1C3E64",
							}}
							mb="7px"
							size="sm"
						>
							Upload Images
						</Button>
					</GridItem>
				</Grid>
				<br />
				{uploadedImages.length > 0 ? (
					<Flex gap="8px" flexWrap="wrap">
						{uploadedImages.map((image, index) => (
							<a href={image} key={index} target="_blank">
								<Flex
									flexDirection={"column"}
									justifyContent="center"
									alignItems="center"
									gap="5px"
								>
									<Image
										src={image}
										alt="Image"
										h="60px"
										w="70px"
										minWidth="70px"
									/>
								</Flex>
							</a>
						))}
					</Flex>
				) : null}
			</FormControl>

			<CustomSpinner isSpinnerOpen={isOpen} />
		</>
	);
};

export default SubmitPropertyForm1;
